import React, { useContext } from "react";
import "./Mobile.scss";
import { FaPhoneAlt } from "react-icons/fa";
import MyContext from "../../../../Uttis/MyContext";

const Mobile = () => {

  const{handleCallClick}=useContext(MyContext)
  return (
    <div className="mobile-card" onClick={handleCallClick}>
      <a href="tel:+919664768292" className="contact-link">
        <FaPhoneAlt className="phone-icon" />
        <span className="phone-number" >+91 96647 68292</span>
      </a>
    </div>
  );
};

export default Mobile;
